import { CustomerPlanCards } from "./CustomerPlanCards";

export const BillingPlanSelector = ({ plans, selectedPlan, onSelect, isExpired }) => (
  <CustomerPlanCards
    context="billing"
    headline={isExpired ? "Restore your Wizard X workspace" : "Renew access or change your term"}
    isExpired={isExpired}
    onSelect={onSelect}
    plans={plans}
    selectedPlan={selectedPlan}
  />
);